export enum CartUpdateType {
  MEMORY = 'MEMORY',
  CART = 'CART',
}

export enum AutoRenewalConfirmationStatus {
  PENDING = 'PENDING',
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
}
